// error-handler.ts
export const handleApiError = (error: any, defaultMessage = "An error occurred") => {
  if (error.response) {
    return new Error(error.response.data?.message || defaultMessage);
  }
  return new Error(defaultMessage);
};